import {Box, ThemeProvider} from '@primer/react-brand/esm'
import {WebGLPage} from '@github-ui/brand-webgl'
import type {FlexSuiteCategoryPage} from '../types'
import {FlexSuiteHero} from '../components/FlexSuiteHero'
import {FlexSuiteSubNav} from '../components/FlexSuiteSubNav'

export type CategoryTemplateProps = {
  page: FlexSuiteCategoryPage
}

export function CategoryTemplate({page}: CategoryTemplateProps) {
  const {template, settings} = page.fields
  const pageColorMode = settings?.fields.colorMode ?? 'light'
  const {
    subNav,
    heroHeading,
    heroLabel,
    heroDescription,
    heroVariant,
    heroAsset,
    heroCtaOne,
    heroCtaTwo,
    heroImageCards,
    heroIconCards,
  } = template.fields

  return (
    <ThemeProvider colorMode={pageColorMode}>
      {/* Keep background synchronized with the current color mode */}
      <Box backgroundColor="default">
        <WebGLPage mode={pageColorMode}>
          {subNav && <FlexSuiteSubNav subNav={subNav} />}
          <FlexSuiteHero
            heroHeading={heroHeading}
            heroLabel={heroLabel}
            heroDescription={heroDescription}
            heroVariant={heroVariant}
            heroAsset={heroAsset}
            heroCtaOne={heroCtaOne}
            heroCtaTwo={heroCtaTwo}
            heroImageCards={heroImageCards}
            heroIconCards={heroIconCards}
            showDither
            options={{
              variant: 'gridline',
              align: 'center',
              enableAnimation: true,
              textVariant: heroVariant === '50/50' ? 'muted' : 'default',
            }}
          />
        </WebGLPage>
      </Box>
    </ThemeProvider>
  )
}
